/* eslint-disable no-unused-vars */
export enum ExpiryDateEnums {
  ANALYTICS_EXPIRY_DATE = '2024-03-31',
}
